import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { Link, Redirect } from 'react-router-dom';

import MySnackbarContentWrapper from '../../shared/snackbars/MySnackbarContentWrapper';
import {
  getUserAddresses,
  createAddress,
} from '../../shared/requests/AddressRequests';
import validate from '../../shared/validators/AddressValidator';
import AddressForm from './AddressForm';
import ShippingMethodForm from './ShippingMethodForm';
import PaymentForm from './PaymentForm';
import Review from './Review';
import {
  getBraintreeClientToken,
  getBraintreeCustomer,
  createBraintreeCustomer,
  createBraintreePaymentMethod,
} from '../../shared/requests/BillingRequests';
import {
  getCart,
  getLines,
  getLine,
} from '../../shared/requests/shop/CartRequests';
import { getOscarAccount } from '../../shared/requests/shop/OscarAccountRequests';
import {
  checkoutPreview,
  getShippingMethods,
  getCountries,
  placeOrder,
  submitPayment,
} from '../../shared/requests/shop/CheckoutRequests';
import {
  productSortByID,
  lineSortByID,
} from '../../shared/Helpers';
import sessionConstants from '../../constants/SessionConstants';
import { getUserInfo } from '../../shared/requests/UserInfoRequests';
import { userLogoutRequestSynch } from '../../actions/LogoutActions';

import errorIcon from '../../static/img/icons/warning_icon.svg';
import successIcon from '../../static/img/icons/checked_icon.svg';


const styles = theme => ({
  header: {
    textAlign: 'center',
    margin: theme.spacing(5),
  },
  loadingSpinner: {
    verticalAlign: 'middle',
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
    [theme.breakpoints.up(600 + theme.spacing(3 * 2))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(6),
    },
  },
  stepper: {
    padding: `${theme.spacing(3)}px 0 ${theme.spacing(5)}px`,
  },
  buttons: {
    // display: 'flex',
    // justifyContent: 'flex-end',
    maxHeight: 30,
  },
  button: {
    // marginTop: theme.spacing(3),
    marginLeft: theme.spacing(),
  },
  buttonsContainer: {
    marginTop: theme.spacing(3),
  },
  statusIcon: {
    margin: theme.spacing(2),
    height: 40,
    width: 40,
  },
  statusMessage: {
    textAlign: 'center',
  },
  backToPaymentButton: {
    marginTop: theme.spacing(2),
  },
  errorIcon: {
    height: 80,
    width: 80,
    marginBottom: theme.spacing(3),
  },
  loggedOutContainer: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  loggedOutOptions: {
    margin: theme.spacing(2),
  },
  link: {
    color: theme.palette.blue,
    textDecoration: 'none',
  },
  downloadsText: {
    marginTop: theme.spacing(2),
  },
});

function getCountryUrl(countries, country) {
  let ret = '';
  countries.forEach((c) => {
    const a2 = c.url.split('/')[5];
    if (a2 === country) {
      ret = c.url;
    }
  });
  return ret;
}

const steps = ['Shipping address', 'Shipping Method', 'Payment Method', 'Review your order'];

function getStepContent(
  step,
  addresses,
  activeAddress,
  changeAddress,
  onChange,
  addressFName,
  addressLName,
  addressLine1,
  addressLine2,
  addressCity,
  addressState,
  addressZip,
  addressCountry,
  addressErrors,
  addressErrorStates,
  handleSaveAddressChange,
  addressHasChanged,
  saveAddress,
  braintreeCustomer,
  activePayment,
  handleSelectPayment,
  handleToggleSavePayment,
  savePayment,
  paymentMethod,
  handleInstance,
  lines,
  cart,
  products,
  braintreeClientToken,
  oscarAccount,
  handleStoreCreditChange,
  useStoreCredit,
  methodRequired,
  acceptTCs,
  handleTCsChange,
  shippingCharge,
  shippingMethods,
  activeShippingMethod,
  handleShippingMethodChange,
  shippingRequired,
) {
  switch (step) {
    case 0:
      return (
        <AddressForm
          addresses={addresses}
          activeAddress={activeAddress}
          changeAddress={changeAddress}
          onChange={onChange}
          addressFName={addressFName}
          addressLName={addressLName}
          addressLine1={addressLine1}
          addressLine2={addressLine2}
          addressCity={addressCity}
          addressState={addressState}
          addressZip={addressZip}
          addressCountry={addressCountry}
          addressErrors={addressErrors}
          addressErrorStates={addressErrorStates}
          handleSaveAddressChange={handleSaveAddressChange}
          addressHasChanged={addressHasChanged}
          saveAddress={saveAddress}
        />
      );
    case 1:
      return (
        <ShippingMethodForm
          shippingRequired={shippingRequired}
          shippingMethods={shippingMethods}
          activeShippingMethod={activeShippingMethod}
          handleShippingMethodChange={handleShippingMethodChange}
        />
      );
    case 2:
      return (
        <PaymentForm
          braintreeCustomer={braintreeCustomer}
          activePayment={activePayment}
          handleSelectPayment={handleSelectPayment}
          handleToggleSavePayment={handleToggleSavePayment}
          savePayment={savePayment}
          handleInstance={handleInstance}
          braintreeClientToken={braintreeClientToken}
          paymentRequired={parseFloat(cart.total_incl_tax) + parseFloat(shippingCharge.incl_tax) > 0}
          oscarAccount={oscarAccount}
          cart={cart}
          handleStoreCreditChange={handleStoreCreditChange}
          useStoreCredit={useStoreCredit}
          methodRequired={methodRequired}
          shippingCharge={shippingCharge}
        />
      );
    case 3:
      return (
        <Review
          addressFName={addressFName}
          addressLName={addressLName}
          addressLine1={addressLine1}
          addressLine2={addressLine2}
          addressCity={addressCity}
          addressState={addressState}
          addressZip={addressZip}
          addressCountry={addressCountry}
          paymentMethod={paymentMethod}
          lines={lines}
          cart={cart}
          products={products}
          useStoreCredit={useStoreCredit}
          oscarAccount={oscarAccount}
          methodRequired={methodRequired}
          acceptTCs={acceptTCs}
          handleTCsChange={handleTCsChange}
          shippingCharge={shippingCharge}
        />
      );
    default:
      throw new Error('Unknown step');
  }
}

function displayOrderStatus(orderStatus, paymentStatus, classes, order, returnToPaymentOptions) {
  if ((paymentStatus === 'success') && (orderStatus === 'success')) { // all good
    return (
      <div className={classes.statusMessage}>
        <Typography variant="h6">Your order has been placed</Typography>
        <img className={classes.statusIcon} alt="success icon" src={successIcon} />
        <Typography variant="subtitle1">{'Your order number is #' + order.number}</Typography>
        <Typography className={classes.downloadsText} color="textSecondary" variant="subtitle1">
          If your order contained any digital downloads, you can now find them in the
          <a className={classes.link} href="/account/downloads">{' downloads tab '}</a>
          of your account.
        </Typography>
      </div>
    );
  }
  if ((orderStatus === 'error') || (paymentStatus === 'error')) { // there was an error in one or both of the steps
    return (
      <div className={classes.statusMessage}>
        <Typography variant="h6">There was an error placing your order</Typography>
        <img className={classes.statusIcon} alt="error icon" src={errorIcon} />
        <React.Fragment>
          {paymentStatus === 'error'
            ? (
              <React.Fragment>
                <Typography variant="subtitle1">Payment failed</Typography>
                <Typography>Please try a different payment option</Typography>
                <Button color="secondary" variant="contained" className={classes.backToPaymentButton} onClick={returnToPaymentOptions}>Payment Options</Button>
              </React.Fragment>
            )
            : null
          }
          {orderStatus === 'error'
            ? <Typography variant="subtitle1">Your charge was accepted but there was an error placing your order. Please contact customer service and we will sort it out immediately.</Typography>
            : null
          }
        </React.Fragment>
      </div>
    );
  }
  return ( // pre requests
    <div className={classes.statusMessage}>
      <Typography variant="h6">Placing your order..</Typography>
      <CircularProgress color="secondary" />
    </div>
  );
}

function getPreferredAddress(addresses) {
  let ret = 0;
  addresses.forEach((address, i) => {
    if (address.is_default_for_shipping) {
      ret = i;
    }
  });
  return ret;
}


class Checkout extends React.Component {
  constructor(props) {
    super(props);
    const { id } = this.props;

    this.state = {
      loading: true,
      // address form
      addressFormLoading: false,
      addresses: [],
      activeAddress: 0,
      addressFName: '',
      addressLName: '',
      addressLine1: '',
      addressLine2: '',
      addressCity: '',
      addressState: '',
      addressZip: '',
      addressCountry: '',
      addressErrors: {},
      addressErrorStates: {
        addressFName: false,
        addressLName: false,
        addressLine1: false,
        addressLine2: false,
        addressCity: false,
        addressState: false,
        addressZip: false,
        addressCountry: false,
      },
      snackbarOpen: false,
      snackbarVariant: '',
      snackbarMessage: '',
      activeStep: 0,
      saveAddress: false,
      addressHasChanged: false,
      // payment form
      instance: {},
      braintreeCustomer: {},
      activePayment: 0,
      savePayment: false,
      payFormLoading: false,
      paymentMethod: {},
      // cart
      cart: null,
      lines: [],
      products: [],
      // order
      order: {},
      orderStatus: 'pre',
      paymentStatus: 'pre',
      braintreeClientToken: '',
      oscarAccount: {},
      useStoreCredit: false,
      methodRequired: true,
      acceptTCs: false,
      shippingCharge: {},
      shippingMethods: [],
      activeShippingMethod: '',
      countries: [],
      shippingRequired: true,
      shippingFormLoading: false,
      orderFormLoading: false,
      redirect: !id,
      redirectReason: sessionConstants.LOGIN_REQUIRED,
    };

    this.onChange = this.onChange.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.changeAddress = this.changeAddress.bind(this);
    this.addressNextButtonState = this.addressNextButtonState.bind(this);
    this.paymentNextButtonState = this.paymentNextButtonState.bind(this);
    this.shippingMethodNextButtonState = this.shippingMethodNextButtonState.bind(this);
    this.reviewButtonState = this.reviewButtonState.bind(this);
    this.handleSaveAddressChange = this.handleSaveAddressChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSelectPayment = this.handleSelectPayment.bind(this);
    this.handleToggleSavePayment = this.handleToggleSavePayment.bind(this);
    this.handleNextFromAddress = this.handleNextFromAddress.bind(this);
    this.handleNextFromShippingMethod = this.handleNextFromShippingMethod.bind(this);
    this.handleNextFromPayment = this.handleNextFromPayment.bind(this);
    this.handlePlaceOrder = this.handlePlaceOrder.bind(this);
    this.returnToPaymentOptions = this.returnToPaymentOptions.bind(this);
    this.handleInstance = this.handleInstance.bind(this);
    this.handleStoreCreditChange = this.handleStoreCreditChange.bind(this);
    this.handleTCsChange = this.handleTCsChange.bind(this);
    this.handleShippingMethodChange = this.handleShippingMethodChange.bind(this);
    this.getActiveShippingMethod = this.getActiveShippingMethod.bind(this);
  }

  componentDidMount() {
    const {
      token,
      id,
      location: {
        pathname,
      },
      dispatch,
    } = this.props;

    if (id) {
      // Check if token is active, redirect to login if it is rotten
      getUserInfo(token, id)
        .catch((error) => {
          if (error.response && error.response.status === 403) {
            console.log('token is expired');
            userLogoutRequestSynch(token)(dispatch)
              .then(() => this.setState({ redirect: true, redirectReason: sessionConstants.SESSION_EXPIRED }));
          } else {
            console.log(error);
            console.log('failed to load user info');
          }
        });
      // this is not necessary
      getBraintreeCustomer(token, id)
        .then((response2) => {
          if (response2.status === 204) {
            console.log('no braintree customer on file');
          } else {
            console.log('got braintree customer');
            // console.log(response2.data);
            // 1st source in list is customer's preferred, use it
            if (response2.data && response2.data.payment_methods.length > 0) {
              response2.data.payment_methods.forEach((method, i) => {
                // console.log(method);
                if (method.default === true) {
                  // console.log(method.default);
                  this.setState({
                    activePayment: i + 1,
                  });
                }
              });
            }
            this.setState({
              braintreeCustomer: response2.data,
            });
          }
        })
        .catch((error) => {
          console.log('failed to load braintree customer');
          console.log(error.response);
          // do not set error state, this is ok
        });

      // neither is this
      // get store credit
      getOscarAccount(token, id)
        .then((response) => {
          console.log('got oscar account');
          // console.log(response.data);
          let oscarAccount = {};
          if (response.data.length > 0) { // TODO: might need to check to make sure this is store credit and not something else
            oscarAccount = response.data[0];
          }
          this.setState({
            oscarAccount,
          });
        })
        .catch((error) => {
          console.log('failed to get oscar account');
          console.log(error.response);
          this.setState({
            snackbarOpen: true,
            snackbarVariant: 'error',
            snackbarMessage: 'Something went wrong..',
          });
        });

      // all of these are necessary
      getBraintreeClientToken(token)
        .then((response) => {
          console.log('got braintree client token');
          // console.log(response.data);
          this.setState({
            braintreeClientToken: response.data.token,
          });
          getUserAddresses(token, id)
            .then((response) => {
              console.log('got user addresses:');
              // console.log(response.data);
              if (response.data.length > 0) {
                const active = getPreferredAddress(response.data);
                this.setState({
                  addresses: response.data,
                  activeAddress: active + 1,
                  addressFName: response.data[active].first_name,
                  addressLName: response.data[active].last_name,
                  addressLine1: response.data[active].line1,
                  addressLine2: response.data[active].line2,
                  addressCity: response.data[active].line4,
                  addressState: response.data[active].state,
                  addressZip: response.data[active].postcode,
                  addressCountry: response.data[active].country_id,
                });
              }
              getCart(token) // get cart
                .then((response) => {
                  console.log('got cart');
                  console.log(response.data);
                  this.setState({
                    cart: response.data,
                  });
                  getLines(token, this.state.cart.lines) // get cart lines
                    .then((response) => {
                      console.log('got cart lines');
                      console.log(response.data);
                      if (response.data.length < 1) {
                        // don't load products
                        this.setState({
                          lines: lineSortByID(response.data),
                          loading: false,
                        });
                      } else {
                        // load products
                        this.setState({
                          lines: lineSortByID(response.data),
                        });
                        response.data.forEach(line => (
                          getLine(token, line.product) // get each individual line product
                            .then((response) => {
                              console.log('got single line');
                              // console.log(response.data);
                              this.setState({
                                products: productSortByID(this.state.products.concat([response.data])),
                                loading: false,
                              });
                            })
                            .catch((error) => {
                              console.log('failed to load line');
                              console.log(error);
                              this.setState({
                                snackbarOpen: true,
                                snackbarVariant: 'error',
                                snackbarMessage: 'Something went wrong..',
                                loading: false,
                              });
                            })
                        ));
                      }
                    })
                    .catch((error) => {
                      console.log('failed to load cart lines');
                      console.log(error);
                      this.setState({
                        snackbarOpen: true,
                        snackbarVariant: 'error',
                        snackbarMessage: 'Something went wrong..',
                        loading: false,
                      });
                    });
                })
                .catch((error) => {
                  console.log('failed to load cart');
                  console.log(error);
                  this.setState({
                    snackbarOpen: true,
                    snackbarVariant: 'error',
                    snackbarMessage: 'Something went wrong..',
                    loading: false,
                  });
                });
            })
            .catch((error) => {
              console.log('failed to load user addresses');
              console.log(error);
              this.setState({
                snackbarOpen: true,
                snackbarVariant: 'error',
                snackbarMessage: 'Failed to load your saved addresses',
                loading: false,
              });
            });
        })
        .catch((error) => {
          console.log('failed to get braintree client token');
          console.log(error);
          this.setState({
            snackbarOpen: true,
            snackbarVariant: 'error',
            snackbarMessage: 'Something went wrong..',
            loading: false,
          });
        });
    } else {
      window.location.href = `/login?to=${encodeURIComponent(pathname)}&reason=${encodeURIComponent(sessionConstants.LOGIN_REQUIRED)}`;
    }
  }

  // generic change handler
  onChange(e) {
    e.preventDefault();
    const change = {};
    const n = e.target.name;
    change[n] = e.target.value;
    const { addressErrors, addressErrorStates } = this.state;
    [addressErrors[n], addressErrorStates[n]] = validate(e.target.value, n);
    change[addressErrors] = addressErrors;
    change[addressErrorStates] = addressErrorStates;
    change.addressHasChanged = true;
    change.activeAddress = 0;
    this.setState(change);
  }

  getActiveShippingMethod() {
    const { shippingMethods, activeShippingMethod } = this.state;
    let shippingMethod = shippingMethods[0];
    shippingMethods.forEach((shipMethod) => {
      if (shipMethod.name === activeShippingMethod) {
        shippingMethod = shipMethod;
      }
    });
    return shippingMethod;
  }

  handleNextFromAddress() {
    const { token, id } = this.props;
    const {
      activeStep,
      saveAddress,
      addressHasChanged,
      addressFName,
      addressLName,
      addressLine1,
      addressLine2,
      addressCity,
      addressState,
      addressZip,
      addressCountry,
      activeAddress,
      cart,
    } = this.state;
    this.setState({
      addressFormLoading: true,
    });
    if (addressHasChanged && saveAddress && (activeAddress === 0)) {
      createAddress(
        token,
        id,
        addressFName,
        addressLName,
        addressLine1,
        addressLine2,
        addressCity,
        addressState,
        addressZip,
        addressCountry,
      )
        .then((response) => {
          console.log('created user address');
          // console.log(response.data);
          this.setState({
            snackbarOpen: true,
            snackbarVariant: 'success',
            snackbarMessage: 'Address saved',
          });
        })
        .catch((error) => {
          console.log('failed to create user address');
          console.log(error);
          this.setState({
            snackbarOpen: true,
            snackbarVariant: 'error',
            snackbarMessage: 'Failed to save address',
          });
        });
    }
    // first we need to get the country URL
    getCountries(token)
      .then((response1) => {
        console.log('got countries');
        // next we need to get shipping
        this.setState({
          countries: response1.data,
        });
        getShippingMethods(
          token,
          cart.url,
          getCountryUrl(response1.data, addressCountry), // country url
          addressFName,
          addressLName,
          addressLine1,
          addressLine2,
          addressCity,
          addressState,
          addressZip,
        )
          .then((response2) => {
            console.log('got shipping methods');
            console.log(response2.data);
            this.setState({
              activeShippingMethod: response2.data[0].name,
              shippingMethods: response2.data,
              activeStep: activeStep + 1,
              addressFormLoading: false,
            });
          })
          .catch((error) => {
            console.log('failed to get shipping methods');
            console.log(error);
            this.setState({
              addressFormLoading: false,
              snackbarOpen: true,
              snackbarVariant: 'error',
              snackbarMessage: 'Something went wrong..',
            });
          });
      })
      .catch((error) => {
        console.log('failed to get countries');
        // console.log(error);
        this.setState({
          addressFormLoading: false,
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Something went wrong..',
        });
      });
  }

  handleNextFromShippingMethod() {
    const { token, email } = this.props;
    const {
      activeStep,
      addressFName,
      addressLName,
      addressLine1,
      addressLine2,
      addressCity,
      addressState,
      addressZip,
      addressCountry,
      cart,
      countries,
    } = this.state;

    this.setState({
      shippingFormLoading: true,
    });
    // get shipping method object from list cause radios are stupid and dont use indices
    let shippingMethod = this.getActiveShippingMethod();

    // finally we can place the order to checkout
    checkoutPreview(
      token,
      cart.url,
      email,
      shippingMethod.code,
      getCountryUrl(countries, addressCountry), // country url
      addressFName,
      addressLName,
      addressLine1,
      addressLine2,
      addressCity,
      addressState,
      addressZip,
    )
      .then((response) => {
        console.log('submitted cart to review');
        console.log(response.data);
        this.setState({
          cart: response.data.basket,
          shippingCharge: response.data.shipping_charge,
          shippingFormLoading: false,
          activeStep: activeStep + 1,
        });
      })
      .catch((error) => {
        console.log('failed to submit cart to review');
        console.log(error.response);
        this.setState({
          shippingFormLoading: false,
          snackbarOpen: true,
          snackbarVariant: 'error',
          snackbarMessage: 'Something went wrong..',
        });
      });
  }

  handleNextFromPayment() {
    const { token, id } = this.props;
    const {
      activeStep,
      activePayment,
      savePayment,
      braintreeCustomer,
      instance,
      methodRequired,
    } = this.state;
    if (!methodRequired) {
      this.setState({ activeStep: activeStep + 1 });
    } else if (activePayment === 0) {
      this.setState({
        payFormLoading: true,
      });
      instance.requestPaymentMethod() // dropin creates payment nonce
        .then((response) => {
          if (!response.error) { // payment nonce created ok
            console.log('created payment nonce');
            // console.log(response);
            this.setState({
              paymentMethod: response,
            });
            if (savePayment) { // should we save the source for later?
              console.log('should save payment method to customer');
              if (!braintreeCustomer) { // do we have a customer to save to?
                console.log('no braintree customer, creating now');
                // console.log(braintreeCustomer);
                createBraintreeCustomer(token, id)
                  .then((response2) => {
                    console.log('created braintree customer:');
                    // console.log(response2.data);
                    this.setState({
                      braintreeCustomer: response2.data,
                    });
                    // we now definitely have a customer, add the payment method
                    createBraintreePaymentMethod(token, id, response.nonce, false)
                      .then((response3) => {
                        console.log('added payment method to customer');
                        // console.log(response3);
                        this.setState({
                          paymentMethod: response3.data, // set new payment method as one to be used
                          snackbarOpen: true,
                          snackbarVariant: 'success',
                          snackbarMessage: 'New payment method saved',
                          payFormLoading: false,
                          savePayment: false,
                        });
                        getBraintreeCustomer(token, id) // reload braintree customer cause new pay method
                          .then((response4) => {
                            console.log('got braintree customer');
                            this.setState({
                              braintreeCustomer: response4.data,
                              activePayment: 1, // 1st payment method (2nd item in select list)
                              activeStep: activeStep + 1, // finished with this step
                            });
                          })
                          .catch((error4) => {
                            console.log('failed to get braintree customer');
                            console.log(error4.response);
                            this.setState({
                              snackbarOpen: true,
                              snackbarVariant: 'error',
                              snackbarMessage: 'Something went wrong..',
                            });
                          });
                      })
                      .catch((error) => {
                        console.log('failed to add source to customer');
                        // console.log(error);
                        this.setState({
                          snackbarOpen: true,
                          snackbarVariant: 'error',
                          snackbarMessage: 'Failed to save payment method',
                          payFormLoading: false,
                          savePayment: false,
                          // activeStep: activeStep + 1 // do we let them continue?
                        });
                      });
                  })
                  .catch((error) => {
                    console.log('failed to create braintree customer');
                    // console.log(error.response);
                    this.setState({
                      snackbarOpen: true,
                      snackbarVariant: 'error',
                      snackbarMessage: 'Something went wrong..',
                      payFormLoading: false,
                      savePayment: false,
                      // activeStep: activeStep + 1 // do we let them continue?
                    });
                  });
              } else {
                // aready have a braintree customer, add the payment method
                createBraintreePaymentMethod(token, id, response.nonce, false)
                  .then((response3) => {
                    console.log('added payment_method to customer');
                    // console.log(response3);
                    this.setState({
                      paymentMethod: response3.data, // set new payment method as one to be used
                      snackbarOpen: true,
                      snackbarVariant: 'success',
                      snackbarMessage: 'New payment method saved',
                      payFormLoading: false,
                      savePayment: false,
                    });
                    getBraintreeCustomer(token, id) // reload braintree customer cause new pay method
                      .then((response4) => {
                        console.log('got braintree customer');
                        this.setState({
                          braintreeCustomer: response4.data,
                          activePayment: 1, // 1st payment method (2nd item in select list)
                          activeStep: activeStep + 1, // finished with this step
                        });
                      })
                      .catch((error4) => {
                        this.setState({
                          snackbarOpen: true,
                          snackbarVariant: 'error',
                          snackbarMessage: 'Something went wrong..',
                        });
                      });
                  })
                  .catch((error) => {
                    console.log('failed to add source to customer');
                    console.log(error.response);
                    this.setState({
                      snackbarOpen: true,
                      snackbarVariant: 'error',
                      snackbarMessage: 'Failed to save payment method',
                      payFormLoading: false,
                      savePayment: false,
                      // activeStep: activeStep + 1 // do we let them continue?
                    });
                  });
              }
            } else { // don't save for later, just use one-time source.
              this.setState({
                activeStep: activeStep + 1,
                payFormLoading: false,
              });
            }
          } else { // error from braintree dropin
            console.log(response.error);
            this.setState({
              snackbarOpen: true,
              snackbarVariant: 'error',
              snackbarMessage: response.error.message,
              payFormLoading: false,
              savePayment: false,
            });
          }
        });
    } else { // user is using a saved payment method
      // console.log(braintreeCustomer.payment_methods[activePayment - 1]);
      console.log('active payment method token:' + braintreeCustomer.payment_methods[activePayment - 1].token + ', active payment: ' + activePayment);
      this.setState({
        activeStep: activeStep + 1,
        paymentMethod: braintreeCustomer.payment_methods[activePayment - 1],
      });
    }
  }

  handlePlaceOrder() {
    const { token, email, id } = this.props;
    const {
      activeStep,
      addressFName,
      addressLName,
      addressLine1,
      addressLine2,
      addressCity,
      addressState,
      addressZip,
      addressCountry,
      cart,
      // order,
      // braintreeCustomer,
      paymentMethod,
      useStoreCredit,
      shippingCharge,
      countries,
    } = this.state;
    this.setState({
      orderFormLoading: true,
    });
    // how are they paying?
    let pay = '';
    let type = '';
    if (paymentMethod.token) {
      pay = paymentMethod.token;
      type = 'token';
    } else if (paymentMethod.nonce) {
      pay = paymentMethod.nonce;
      type = 'nonce';
    }
    // add shipping to total
    let total = parseFloat(cart.total_incl_tax, 2);
    if (shippingCharge) {
      total += parseFloat(shippingCharge.incl_tax, 2);
    }
    total = total.toFixed(2);

    // get shipping method
    const shippingMethod = this.getActiveShippingMethod();

    if (cart.total_incl_tax > 0) {
      submitPayment(
        token,
        total,
        id,
        pay,
        type,
        useStoreCredit,
      )
        .then((response3) => {
          console.log('submitted payment');
          // console.log(response3.data);
          if (response3.status === 201) {
            this.setState({
              paymentStatus: 'success',
            });
            // finally we can place the order to checkout
            placeOrder(
              token,
              cart.url,
              email,
              total,
              shippingMethod.code, // shipping method code
              shippingCharge,
              getCountryUrl(countries, addressCountry), // country url
              addressFName,
              addressLName,
              addressLine1,
              addressLine2,
              addressCity,
              addressState,
              addressZip,
              response3.data.sources, // pass these right back to server
            )
              .then((response4) => {
                console.log('placed order');
                // console.log(response4.data);
                this.setState({
                  order: response4.data,
                  orderStatus: 'success',
                  orderFormLoading: false,
                });
              })
              .catch((error4) => {
                console.log('failed to place order');
                console.log(error4);
                this.setState({
                  orderStatus: 'error',
                  snackbarOpen: true,
                  snackbarVariant: 'error',
                  snackbarMessage: 'Failed to place order',
                  orderFormLoading: false,
                });
              });
          } else {
            console.log('failed to submit payment');
            console.log(response3.data);
            this.setState({
              paymentStatus: 'error',
              snackbarOpen: true,
              snackbarVariant: 'error',
              snackbarMessage: 'There was a problem processing your payment. Please check your payment method and try again.',
              orderFormLoading: false,
            });
          }
        })
        .catch((error) => {
          // shouldn't ever get here
          console.log('failed to submit payment');
          console.log(error.response);
          this.setState({
            paymentStatus: 'error',
            snackbarOpen: true,
            snackbarVariant: 'error',
            snackbarMessage: 'There was a problem processing your payment. Please check your payment method and try again.',
            orderFormLoading: false,
          });
        });
    } else {
      console.log('no payment required, placing order');
      // finally we can place the order to checkout
      placeOrder(
        token,
        cart.url,
        email,
        cart.total_incl_tax,
        shippingMethod.code, // shipping method code
        getCountryUrl(countries, addressCountry), // country url
        addressFName,
        addressLName,
        addressLine1,
        addressLine2,
        addressCity,
        addressState,
        addressZip,
        useStoreCredit,
      )
        .then((response4) => {
          console.log('placed order');
          // console.log(response4.data);
          this.setState({
            order: response4.data,
            orderStatus: 'success',
            paymentStatus: 'success',
            orderFormLoading: false,
          });
        })
        .catch((error4) => {
          console.log('failed to place order');
          console.log(error4);
          this.setState({
            orderStatus: 'error',
            snackbarOpen: true,
            snackbarVariant: 'error',
            snackbarMessage: 'Failed to place order',
            orderFormLoading: false,
          });
        });
    }


    this.setState({
      activeStep: activeStep + 1,
      saveAddress: false,
      orderFormLoading: false,
    });
  }

  handleBack() {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
      saveAddress: false,
    });
  }

  returnToPaymentOptions() {
    this.setState({
      activeStep: 1,
      paymentStatus: 'pre',
    });
  }

  handleSaveAddressChange(e) {
    this.setState({
      saveAddress: e.target.checked,
    });
  }

  handleToggleSavePayment(e) {
    this.setState({
      savePayment: e.target.checked,
    });
  }

  handleTCsChange(e) {
    this.setState({
      acceptTCs: e.target.checked,
    });
  }

  handleShippingMethodChange(e) {
    this.setState({
      activeShippingMethod: e.target.value,
    });
  }

  // change the address in the form fields to the saved address that was selected in dropdown
  changeAddress(e) {
    let i = e.target.value;
    const { addresses } = this.state;
    this.setState({
      activeAddress: i,
    });
    if (i > 0) {
      i -= 1; // handle "new address" at index 0 in menu"
      this.setState({
        addressFName: addresses[i].first_name,
        addressLName: addresses[i].last_name,
        addressLine1: addresses[i].line1,
        addressLine2: addresses[i].line2,
        addressCity: addresses[i].line4,
        addressState: addresses[i].state,
        addressZip: addresses[i].postcode,
        addressCountry: addresses[i].country_id,
        addressErrors: {},
        addressErrorStates: {
          addressFName: false,
          addressLName: false,
          addressLine1: false,
          addressLine2: false,
          addressCity: false,
          addressState: false,
          addressZip: false,
          addressCountry: false,
        },
        addressHasChanged: false,
        saveAddress: false,
      });
    } else {
      this.setState({
        addressFName: '',
        addressLName: '',
        addressLine1: '',
        addressLine2: '',
        addressCity: '',
        addressState: '',
        addressZip: '',
        addressCountry: '',
        addressErrors: {},
        addressErrorStates: {
          addressFName: false,
          addressLName: false,
          addressLine1: false,
          addressLine2: false,
          addressCity: false,
          addressState: false,
          addressZip: false,
          addressCountry: false,
        },
        addressHasChanged: false,
        saveAddress: false,
      });
    }
  }

  addressNextButtonState() {
    const {
      addressErrorStates,
      addressFName,
      addressLName,
      addressLine1,
      addressCity,
      addressZip,
      addressCountry,
    } = this.state;
    let disabled = false;
    Object.values(addressErrorStates).forEach((val) => {
      if (val !== false) {
        disabled = true;
      }
    });
    if ((addressFName === '')
      || (addressLName === '')
      || (addressLine1 === '')
      || (addressCity === '')
      || (addressZip === '')
      || (addressCountry === '')) {
      disabled = true;
    }
    return disabled;
  }

  handleSelectPayment(e) {
    const i = e.target.value;
    this.setState({
      activePayment: i,
    });
  }

  paymentNextButtonState() {
    let disabled = false;
    // Object.values(addressErrorStates).forEach((val) => {
    //   if (val !== false) {
    //     disabled = true;
    //   }
    // });
    // if ((addressFName === '')
    //   || (addressLName === '')
    //   || (addressLine1 === '')
    //   || (addressCity === '')
    //   || (addressState === '')
    //   || (addressZip === '')
    //   || (addressCountry === '')) {
    //   disabled = true;
    // }
    return disabled;
  }

  shippingMethodNextButtonState() {
    let disabled = false;
    // TODO
    return disabled;
  }

  reviewButtonState() {
    const {
      acceptTCs,
    } = this.state;
    return !acceptTCs;
  }

  handleClose(e, reason) {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ snackbarOpen: false });
  }

  // braintree dropin instance loaded
  handleInstance(i) {
    this.setState({
      instance: i,
    });
  }

  handleStoreCreditChange(e) {
    const { cart, oscarAccount } = this.state;
    let methodRequired = true;
    if (oscarAccount && e.target.checked) {
      if (parseFloat(cart.total_incl_tax_incl_shipping) < parseFloat(oscarAccount.balance)) { // WHY JAVASCRIPT?! WHY?
        methodRequired = false;
      }
    }
    this.setState({
      useStoreCredit: e.target.checked,
      methodRequired,
    });
  }


  render() {
    const {
      classes,
      location: {
        pathname,
      },
    } = this.props;

    const {
      activeStep,
      loading,
      addresses,
      activeAddress,
      addressFName,
      addressLName,
      addressLine1,
      addressLine2,
      addressCity,
      addressState,
      addressZip,
      addressCountry,
      snackbarOpen,
      snackbarVariant,
      snackbarMessage,
      addressErrors,
      addressErrorStates,
      addressHasChanged,
      saveAddress,
      addressFormLoading,
      braintreeCustomer,
      activePayment,
      savePayment,
      payFormLoading,
      paymentMethod,
      lines,
      cart,
      products,
      order,
      orderStatus,
      paymentStatus,
      braintreeClientToken,
      oscarAccount,
      useStoreCredit,
      methodRequired,
      acceptTCs,
      shippingCharge,
      shippingMethods,
      activeShippingMethod,
      shippingRequired,
      shippingFormLoading,
      orderFormLoading,
      redirect,
      redirectReason,
    } = this.state;

    if (redirect) {
      return (
        <Redirect to={`/login?to=${encodeURIComponent(pathname)}&reason=${encodeURIComponent(redirectReason)}`} />
      );
    }
    if (!loading && lines.length < 1) {
      return (
        <div className={classes.loggedOutContainer}>
          <img alt="error icon" className={classes.errorIcon} src={errorIcon} />
          <Typography className={classes.loggedOutMessage} variant="subtitle1">
            Your Cart is Empty
          </Typography>
          <Button href="/shop/routines" className={classes.loggedOutOptions} variant="outlined" color="primary">Go Shopping!</Button>
        </div>
      );
    }
    return (
      <React.Fragment>
        <Typography className={classes.header} color="textSecondary" variant="h4">Checkout</Typography>
        <Paper className={classes.paper}>
          {loading
            ? <CircularProgress color="secondary" className={classes.loadingSpinner} />
            : (
              <React.Fragment>
                <Stepper activeStep={activeStep} className={classes.stepper}>
                  {steps.map(label => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
                {activeStep === steps.length ? (
                  <React.Fragment>
                    {displayOrderStatus(
                      orderStatus,
                      paymentStatus,
                      classes,
                      order,
                      this.returnToPaymentOptions,
                    )}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {getStepContent(
                      activeStep,
                      addresses,
                      activeAddress,
                      this.changeAddress,
                      this.onChange,
                      addressFName,
                      addressLName,
                      addressLine1,
                      addressLine2,
                      addressCity,
                      addressState,
                      addressZip,
                      addressCountry,
                      addressErrors,
                      addressErrorStates,
                      this.handleSaveAddressChange,
                      addressHasChanged,
                      saveAddress,
                      braintreeCustomer,
                      activePayment,
                      this.handleSelectPayment,
                      this.handleToggleSavePayment,
                      savePayment,
                      paymentMethod,
                      this.handleInstance,
                      lines,
                      cart,
                      products,
                      braintreeClientToken,
                      oscarAccount,
                      this.handleStoreCreditChange,
                      useStoreCredit,
                      methodRequired,
                      acceptTCs,
                      this.handleTCsChange,
                      shippingCharge,
                      shippingMethods,
                      activeShippingMethod,
                      this.handleShippingMethodChange,
                      shippingRequired,
                    )}
                    <Grid container justifycontent="space-between" className={classes.buttonsContainer}>
                      <Grid item>
                        <Button component={Link} to="/shop/music">Back to Shopping</Button>
                        <Button component={Link} to="/shop/cart">Back to Cart</Button>
                      </Grid>
                      <Grid item className={classes.buttons}>
                        {(addressFormLoading || shippingFormLoading || payFormLoading || orderFormLoading) && <CircularProgress color="secondary" className={classes.loadingSpinner} />}
                        {activeStep !== 0 && (
                          <Button onClick={this.handleBack} className={classes.button}>
                            Previous
                          </Button>
                        )}
                        {activeStep === 0 && (
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={this.handleNextFromAddress}
                            className={classes.button}
                            disabled={this.addressNextButtonState()}
                          >
                            Next
                          </Button>
                        )}
                        {activeStep === 1 && (
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={this.handleNextFromShippingMethod}
                            className={classes.button}
                            disabled={this.shippingMethodNextButtonState()}
                          >
                            Next
                          </Button>
                        )}
                        {activeStep === 2 && (
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={this.handleNextFromPayment}
                            className={classes.button}
                            disabled={this.paymentNextButtonState()}
                          >
                            Next
                          </Button>
                        )}
                        {activeStep === 3 && (
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={this.handlePlaceOrder}
                            className={classes.button}
                            disabled={this.reviewButtonState()}
                          >
                            Place order
                          </Button>
                        )}
                      </Grid>
                    </Grid>
                  </React.Fragment>
                )}
              </React.Fragment>
            )
          }
        </Paper>
        {/* SNACKBAR */}
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={!loading && snackbarOpen}
          autoHideDuration={5000}
          onClose={this.handleClose}
        >
          <MySnackbarContentWrapper
            onClose={this.handleClose}
            variant={snackbarVariant}
            message={snackbarMessage}
          />
        </Snackbar>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  let id = null;
  let token = null;
  let email = null;
  if (state.loginReducer.user) {
    id = state.loginReducer.user.id;
    token = state.loginReducer.token;
    email = state.loginReducer.user.email
  }
  return {
    id,
    token,
    email,
  };
}

Checkout.propTypes = {
  token: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  email: PropTypes.string.isRequired,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withStyles(styles)(connect(mapStateToProps)(Checkout));
